import { css } from "lit";

export default css`
  h1 {
    font-size: var(--mh-font-size-extra-large);
    color: var(--mh-font-color);
  }

  h2 {
    font-size: var(--mh-font-size-large);
    color: var(--mh-font-color);
  }

  h3 {
    font-size: var(--mh-font-size-large);
    color: var(--mh-font-color);
    font-weight: 100;
  }

  h4 {
    font-size: var(--mh-font-size-medium);
    color: var(--mh-font-color);
  }

  h5 {
    font-size: var(--mh-font-size-small);
    color: var(--mh-font-color);
  }

  h6 {
    font-size: var(--mh-font-size-extra-small);
    color: var(--mh-font-color);
  }

  p {
      font-size: var(--mh-font-size-medium);
      color: var(--mh-font-color);
  }
`;